module.exports = __webpack_public_path__ + "static/img/icon-head.1786686659715.png";